import { render, staticRenderFns } from "./commonIsEffective.vue?vue&type=template&id=4e6257ce&scoped=true"
import script from "./commonIsEffective.vue?vue&type=script&lang=js"
export * from "./commonIsEffective.vue?vue&type=script&lang=js"
import style0 from "./commonIsEffective.vue?vue&type=style&index=0&id=4e6257ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6257ce",
  null
  
)

export default component.exports